module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"usageComparisonsTable.headers.name":"Name","usageComparisonsTable.headers.difference":"Difference","usageComparisonsTable.headers.past":"Past","usageComparisonsTable.headers.current":"Current","usageComparisonsTable.exportBtnText":"Export CSV"}}')
  delete Component.options._Ctor
}
